import'rxjs/add/operator/map';
import'rxjs/add/operator/catch';
import'rxjs/add/operator/startWith';
import'rxjs/add/operator/switchMap';
import'rxjs/add/operator/toArray';
import'rxjs/add/observable/of';
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';

import * as subscriptionActions from './subscriptions.actions';
import { SubscriptionsService } from '../subscriptions.service';
export class SubscriptionEffects {

  @Effect()
  loadSubscriptions$: Observable<Action> = this.actions$
    .ofType(subscriptionActions.LOAD_SUBSCRIPTION)
    .switchMap(() =>
      this.subscriptionsService.getSubscriptions().toArray()
        .map((subscriptions: any[]) =>
          new subscriptionActions.LoadSubscriptionSuccess(subscriptions[0]))
        .catch((error) => Observable.of(new subscriptionActions.LoadSubscriptionFailure(error)))
    );
/**
 * @param {?} actions$
 * @param {?} subscriptionsService
 */
constructor(private actions$: Actions,
private subscriptionsService: SubscriptionsService) {
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Actions, },
{type: SubscriptionsService, },
];
}

function SubscriptionEffects_tsickle_Closure_declarations() {
/** @type {?} */
SubscriptionEffects.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SubscriptionEffects.ctorParameters;
/** @type {?} */
SubscriptionEffects.prototype.loadSubscriptions$;
/** @type {?} */
SubscriptionEffects.prototype.actions$;
/** @type {?} */
SubscriptionEffects.prototype.subscriptionsService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
